module.exports = __webpack_public_path__ + "static/img/case8.9433282d.jpg";